<template v-resize="onResize">
    <div class='search'  :style="cssVars" >
        <form class='search_form'>
            <div class='search_form_icon'>
                <svg class="multi-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path class="multi-svg-path"
                          d="M23 36c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13zm0-24c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"></path>
                    <path class="multi-svg-path" d="M32.682 31.267l5.98 5.98-1.414 1.414-5.98-5.98z"></path>
                </svg>
            </div>
            <input class='search_form_input' v-model='searchText' ref="searchInput">
            <!--			<div class='search_form_icon' @click.stop='resetForm()'>-->
            <div class='search_form_icon' onclick="hide()" :style="closeStyles">
                <svg class="multi-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path class="multi-svg-path" d="M37.304 11.282l1.414 1.414-26.022 26.02-1.414-1.413z"></path>
                    <path class="multi-svg-path" d="M12.696 11.282l26.022 26.02-1.414 1.415-26.022-26.02z"></path>
                </svg>
            </div>
        </form>
        <div class='search_result' v-if='total'>
            <div class='search_result_categories'>
                <ul>
                    <li @click="onSelectCategory('all')">
                        <span class='item_title item_title_total'>Все результаты</span><span
                            :class="categoryCount(false)">{{total}}</span>
                    </li>
                    <li v-for='(category,index) in categories' v-bind:key="'category_'+index"
                        @click='onSelectCategory(category.data.id,index)'>
                        <span class='item_title'>{{category.data.name}}</span><span
                            :class='categoryCount(category.data.id)'>{{category.count}}</span>
                    </li>
                </ul>
            </div>
            <div class='search_result_groups'>
                <div :class='widthGroup()' v-if='category_id && category'>
                    <div class='search_result_groups_group_title' v-if='items'>{{category.data.name}}</div>
                    <CellSingleComponent v-if='items' :page='page' :onSelectCategory='onSelectCategory'
                                         :onNextPage='onNextPage' :onPrevPage='onPrevPage' :category='category'
                                         :items_group='items' :size="size"></CellSingleComponent>
                </div>
                <div :class='widthGroup()' v-for='(category,index) in categories' v-bind:key="'item_group_'+index"
                     v-else-if='!category_id'>
                    <div class='search_result_groups_group_title'>{{category.data.name}}</div>
                    <div class='search_result_groups_group_items'>
                        <CellGroupComponent :onSelectCategory='onSelectCategory' :category='category'
                                            :category_index='index' :items='category.items'></CellGroupComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CellGroupComponent from './CellGroupComponent.vue'
    import CellSingleComponent from './CellSingleComponent.vue'
    import sendStats from '../helpers/sendStats'
    import config from "../config";

    export default {
        name: 'SearchComponent',
        components: {
            CellGroupComponent,
            CellSingleComponent
        },
        inject: ['theme', 'customer_id'],
        data: () => ({
            searchText: '',
            categories: [],
            total: 0,
            items: [],
            category_id: null,
            category: [],
            page: 1,
            pageCount: 1,
            windowSize: 1,
            hash: null,
            size: 'l',
        }),
        provide() {
            return {
                searchdata: this
            }
        },
        watch: {
            searchText: function () {
                this.search();
            }
        },
        computed: {
            cssVars() {
                return {
                    '--bg-color': this.theme.background_color,
                    '--hl-1-color': this.theme.hl_1,
                    '--hl-2-color': this.theme.hl_2,
                    '--cross-position': this.theme.cross_position
                }
            },
            closeStyles() {
                if (this.theme.cross_position === 'left') {
                    return {
                        order: -1
                    }
                }
            }
        },
        methods: {
            async search() {
                this.hash = Date.now();
                this.category_id = false;
                if (this.searchText) {
                    try {
                        const url = config.url + '/api/site/categories'
							+ '?q=' + this.searchText
                            + '&hash=' + this.hash
                            + '&user=' + this.customer_id;
                        const response = await fetch(url);
                        const result = await response.json();
                        if (this.hash.toString() === result.hash.toString()) {
                            this.total = result.total;
                            this.categories = result.categories;
                            sendStats(this.customer_id, this.total, this.searchText, this.hash, 0);
                        }
                    } catch (error) {
                        this.resetForm();
                    }
                } else {
                    this.resetForm();
                }
            },
            async searchSingle(page = 1) {
                this.hash = Date.now();
                this.page = page;
                if (this.searchText) {
                    try {
                        const url = config.url + '/api/site/categories/' + this.category_id + '?page=' +
                            this.page + '&q=' + this.searchText + '&hash=' + this.hash + '&s=' + this.size + '&user=' + this.customer_id;
                        const response = await fetch(url);
                        const result = await response.json();
                        if (this.hash.toString() === result.hash.toString()) {
                            this.items = result.items;
                        }
                    } catch (error) {
                        this.resetForm();
                    }
                } else {
                    this.resetForm();
                }
            },
            resetForm() {
                this.categories = [];
                this.items = [];
                this.searchText = '';
                this.total = 0;
                this.page = 1;
                this.category_id = false;
            },
            onSelectCategory(id, index) {
                if (id === 'all') {
                    this.search();
                } else {
                    this.category_id = id;
                    this.category = this.categories[index];
                    this.searchSingle();
                }
            },
            onNextPage() {
                this.page = this.page + 1;
                this.searchSingle(this.page);
            },
            onPrevPage() {
                this.page = this.page - 1;
                if (this.page < 1) {
                    this.page = 1;
                }
                this.searchSingle(this.page);
            },
            categoryCount(id) {
                if (id === this.category_id) {
                    return 'item_count item_count_active';
                } else {
                    return 'item_count';
                }
            },
            widthGroup() {
                if (this.category_id) {
                    return 'search_result_groups_group search_result_groups_group_single';
                } else {
                    return 'search_result_groups_group search_result_groups_group_group';
                }
            },
            focusInput() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.searchInput.focus();
                    }, 0)
                })
            },
            onResize() {
                let resize = false;
                if (window.innerWidth < 900) {
                    if (this.size !== 's') {
                        this.size = 's';
                        resize = true;
                    }
                } else if (window.innerWidth < 1300) {
                    if (this.size !== 'm') {
                        this.size = 'm';
                        resize = true;
                    }
                } else {
                    if (this.size !== 'l') {
                        this.size = 'l';
                        resize = true;
                    }
                }
                if (resize) {
                    this.searchSingle(this.page);
                }
            },
        },
        mounted() {
            this.onResize();
            window.addEventListener('resize', this.onResize);
            this.focusInput();
        },
    }
</script>

<style lang='scss'>
    .loader {
        text-align: center;
        position: absolute;
        width: 100%;
        height: fit-content;
        top: 0;
        bottom: 0;
        margin: auto;
    }

    .search {
        width: 100%;
        background: var(--bg-color);
        position: absolute;
        overflow-y: scroll;
        z-index: 99999;
        top: 0;
        line-height: normal;

        &_form {
            width: 95%;
            margin: 0 auto;
            background: var(--bg-color);
            display: flex;
            justify-content: center;

            &_input {
                width: 70%;
                height: 90px;
                border: none;
                background: var(--bg-color);
                font-size: 34px;
                padding: 0;
            }

            &_icon {
                width: 50px;
                height: 50px;
                margin-top: 24px;
                opacity: .6;
            }
        }

        &_result {
            height: calc(100vh - 90px);
            width: 95%;
            margin: 0 auto;
            background: var(--bg-color);
            display: flex;
            border-top: 2px solid var(--hl-1-color);

            &_categories {
                text-align: left;
                width: 240px;
                padding-left: 40px;

                ul {
                    list-style: none;
                    margin: 0;
                    padding: 56px 0 0 0;
                }

                li {
                    border-bottom: 1px solid var(--hl-2-color);
                    padding: 15px 0;
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;

                    .item_count {
                        padding: 0 5px;
                        border-radius: 5px;
                        color: black;
                        border: 1px solid var(--hl-2-color);
                        height: 20px;
                        margin: auto 0;

                        &_active {
                            background: var(--hl-1-color);
                            color: white;
                        }
                    }

                    &:first-child {
                        border-top: 1px solid var(--hl-2-color);
                    }

                    &:hover {
                        .item_count {
                            background: var(--hl-1-color);
                            opacity: 0.8;
                            color: white;

                        }
                    }
                }
            }

            &_groups {
                padding-top: 15px;
                display: flex;
                flex-wrap: wrap;
                margin-left: 35px;
                flex: 1;
                justify-content: flex-start;

                &_group {
                    &_single {
                        width: 100%
                    }

                    &_group {
                        width: 30%
                    }

                    margin-bottom: 20px;
                    margin-right: 30px;

                    &_items {
                        display: flex;
                    }

                    &_title {
                        font-size: 26px;
                        border-bottom: 1px solid var(--hl-2-color);
                        padding-bottom: 5px;
                        margin-bottom: 10px;
                    }

                    &_item {
                        display: flex;
                        margin-bottom: 10px;

                        &_img {
                            display: flex;
                            justify-content: center;
                            border: 1px solid var(--hl-2-color);
                            margin-right: 15px;
                            width: 80px;
                            height: 80px;
                            position: static;
                            align-items: center;

                            img {
                                max-width: 100%;
                                max-height: 100%;
                            }
                        }

                        &_content {
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-evenly;

                            &_price {
                                color: rgba(0, 0, 0, .55);
                            }
                        }
                    }

                    &_more {
                        color: rgba(100, 119, 136, .7);
                        cursor: pointer;
                    }
                }
            }
        }
    }

    button:focus, input:focus {
        outline: none;
    }

    @media screen and (max-width: 1279px) {
        .search {
            &_result {
                &_groups {
                    &_group {
                        &_group {
                            width: 46%;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1120px) {
        .search {
            &_result {
                &_groups {
                    &_group {
                        &_group {
                            width: 100%;
                            margin-right: 15px
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 680px) {
        .search {
            &_result {
                flex-direction: column;

                &_categories {
                    width: 100%;
                    padding: 0;
                    margin-bottom: 30px;

                    li {
                        padding: 15px;
                    }
                }

                &_groups {
                    margin-left: 0px;

                    &_group {
                        margin: 0;

                        &_title {
                            padding-left: 15px;
                            padding-right: 15px;
                        }

                        &_items {
                            margin: 0 15px;
                        }
                    }
                }
            }
        }
    }
</style>
